import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_PRODUCTS_TABLE } from "../../../constants/FirebaseConstants";

export function useProducts() {
  const { data } = useSWRSubscription("products", (key, { next }) => {
    const q = query(collection(db, FIRESTORE_PRODUCTS_TABLE));
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
